import { createTheme } from '@material-ui/core/styles';
import Colours from './colours';

const theme = createTheme({
  palette: {
    primary:   { main: Colours.Primary },
    secondary: { main: Colours.Secondary },
  },
  shape: {
    borderRadius: 5,
  },
  typography: {
    fontFamily: 'Inter',
    fontSize:   12,
    button:     {
      textTransform: 'none',
    },
  },
  overrides: {
    MuiTableCell: {
      root: {
        fontSize: '0.65rem', // Globally overrides the default body font size for cells
      },
      head: {
        fontSize: '0.7rem', // Globally overrides header cell text size specifically
      },
    },
  },
});

export default theme;
